import axios from 'axios'
import router from '../router'
const instance = axios.create({
  withCredentials: true,
  crossDomain: true
  // headers: {
  //   'Content-Type': 'application/x-www-form-urlencoded'
  // }
})
instance.interceptors.response.use(response=>{
  if(response.data.code!==3){
  return response
  } else {
    router.replace({
      name: 'Login',
  })
  }
})
export default instance
